import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import FormTextArea from 'partial/components/form/FormTextArea';
import Button from 'partial/components/Button';
import { useBanAccount } from '../hooks';

export const useOpenBanAccount = () => {
  const createModal = useCreateModal();

  const openBanAccountModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <BanAccount data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openBanAccountModal;
};

function BanAccount({ onClose, data }) {
  const [reason, setReason] = useState('');
  const [isLoading, ban] = useBanAccount(onClose);
  const label = data?.organization?.is_banned ? 'UNBAN' : 'BAN';
  const submit = () => {
    ban({ uuid: data?.uuid, reason });
  };
  return (
    <ModalCard size="sm" title={`${label} ACCOUNT`} onClose={onClose}>
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to {label} this account
          <span className="text-brand-600"> {data?.organization?.name}</span>?
        </p>
        <FormTextArea
          name="reason"
          onSetFieldValue={(_, value) => setReason(value)}
          value={reason}
          label="Reason"
          autoFocus
        />
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading || reason.length === 0}
            outline
            className="uppercase"
            onClick={submit}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

BanAccount.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BanAccount;
